import { useQuery } from 'src/modules/apollo';
import { useAppConfig } from 'src/modules/appConfig';
import * as Schema from 'src/types/graphql';

export const useSupportedCountries = () => {
  const { language } = useAppConfig();
  const { data, loading, error } = useQuery(
    Schema.GetSupportedCountriesDocument,
    {
      variables: {
        languageCode: language,
      },
    },
  );

  const supportedCountries =
    loading || error ? [] : data?.supportedCountries || [];

  return { supportedCountries, loading, error };
};
